export const NONE_OF_THE_TIME = "None of the time";
export const SOMETIMES = "Sometimes";
export const EVERYDAY = "Everyday";
